import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Search } from "lucide-react";

export default function PublicLayout({ children, hideSearch = false }) {
  return (
    <div className="flex min-h-screen flex-col bg-heda-cream text-heda-ink">
      <header
        className="sticky top-0 z-40 border-b border-heda-line bg-heda-cream/95 backdrop-blur"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 md:px-8 md:py-4">
          <Logo />
          {!hideSearch && (
            <Link to="/search" className="heda-pill" data-testid="header-search-link">
              <Search size={13} />
              <span className="hidden sm:inline">Search</span>
            </Link>
          )}
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="mt-12 border-t border-heda-line">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-[11.5px] text-heda-mute md:flex-row md:items-center md:justify-between md:px-8">
          <div>© {new Date().getFullYear()} Heda Plywoods · Premium plywood, crafted with precision.</div>
          <div>
            Powered by <span className="font-semibold text-heda-ink">Hedaply AI</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
